import { X } from "lucide-react"
import { MouseEvent, useMemo } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Button } from "ui"
import { getSelectedSiteCollaborateInfo } from '../../../../store/siteInfoSlice'
import { clearPendingTask, getCurrentTaskState, getSelectedTask, setCreateModalOpen, setGeneralTaskModalOpen, setSelectedTask, setSelectedTaskId } from '../../../../store/tasksSlice'
import { Screenshot } from "./screenshot/screenshot"
import { TaskStatusGroup } from './task-status/group-task-status'
import { TeamMembers } from './team-members/team-members'
import TechInfo from "./tech-info/tech-info"

export const Header = () => {
    const selectedTask = useSelector(getSelectedTask);
    const { isPending } = useSelector(getCurrentTaskState);
    const collaborateInfo = useSelector(getSelectedSiteCollaborateInfo)
    const dispatch = useDispatch();


    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        dispatch(setCreateModalOpen(false));
        dispatch(setSelectedTaskId(null));
        dispatch(setSelectedTask(undefined));
        dispatch(setGeneralTaskModalOpen(false));
        dispatch(clearPendingTask());
    };

    const infoMap = useMemo(() => {
        if (!selectedTask?.additional_information) return {};
        return selectedTask.additional_information.reduce<
            Record<string, string | number>
        >((acc, item) => {
            const key = item.label
                .replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) =>
                    index === 0 ? letter.toLowerCase() : letter.toUpperCase()
                )
                .replace(/\s+/g, '');
            acc[key] = item.value;
            return acc;
        }, {});
    }, [selectedTask]);

    const hasPermission = useMemo(() => {
        return collaborateInfo?.result?.role === 'admin' || collaborateInfo?.result?.role === 'contributor';
    }, [collaborateInfo?.result?.role]);

    // const isPaid = useMemo(() => {
    //     return (collaborateInfo?.result.plan?.rank || 0) >= 2 || hasPermission;
    // }, [collaborateInfo?.result.plan?.rank, hasPermission]);

    return <div className="flex flex-col gap-1">
        <div className="flex justify-between items-center">
            <div className="flex gap-1 justify-center">
                {hasPermission && <TeamMembers taskDetails={selectedTask} isPendingTask={isPending} />}
                {
                    // isPaid && 
                    <TaskStatusGroup isPendingTask={isPending} taskDetails={selectedTask} />
                }
                {selectedTask && !isPending && (
                    <>
                        <Screenshot
                            taskDetails={selectedTask}
                            isPendingTask={isPending}
                        />
                        <TechInfo infoMap={infoMap} taskDetails={selectedTask} />
                        {/* <Button
                            variant="ghost"
                            size="icon"
                            className="text-destructive hover:text-destructive"
                            tooltip="Errors found on page"
                        >
                            <TriangleAlert size={18} />
                        </Button> */}
                    </>
                )}

            </div>
            <Button size="icon" variant="ghost" className='hover:text-ata-red' onClick={handleClick}><X /></Button>
        </div>
    </div>
}